import Dayjs from 'dayjs';
// 放置一些跟发邮件相关的方法
import {
	__FIELD_NAME_INVOICE_RECEPT__,
	__FIELD_NAME_WARRANTY_CARD__,
	__FIELD_NAME_USER_PANEL__,
	__FIELD_NAME_PRODUCT_PANEL__,
	__FIELD_NAME_PANEL__,
	__FIELD_PRIVACY_POLCY__,
	__FIELD_MARKETING_OPT_IN__,
	__FIELD_OPT_IN__,
} from "@/const/fieldName";

/**
 * 
 * @param {obj} data 
 * @returns Number
 * 获取表单附件总数
 */
export const useFormV3AttachNum = data => {
	let num = 0;
	const recursion = resource => {
		for (const key in resource) {
			// for in 循环包含原型链中的属性，需判断key是否为当前对象的属性
			if (Object.prototype.hasOwnProperty.call(resource, key)) {
				if (resource[key] && [__FIELD_NAME_INVOICE_RECEPT__, __FIELD_NAME_WARRANTY_CARD__].indexOf(key) !== -1) {
					num += resource[key].length;
				}
				if (resource[key] && [__FIELD_NAME_USER_PANEL__, __FIELD_NAME_PRODUCT_PANEL__].indexOf(key) !== -1) {
					resource[key].forEach((item) => {
						recursion(item);
					});
				}
			}
		}
	}
	recursion(data);
	return num;
};

const getCheckboxValue = (bool) => { 
	return bool ? "Y" : "N";
}

// 遍历表单的states，以label为key，值为value，组装发邮件的form data参数
export const useFormV3EmailFormData = (states, formId) => {
	const formData = new FormData();
	formData.append("formId", formId);
	let attachIndex = 0;// 附件索引
	const data = {};// 存放panel数据

	Object.keys(states).forEach(key => {
		const stateItem = states[key];
		// 对checkbox字段单独处理
		if (key === __FIELD_PRIVACY_POLCY__) {// 如果是privacy policy，则要写死label
			data["Privacy Policy"] = getCheckboxValue(stateItem.value);
			return;
		}
		if (key === __FIELD_MARKETING_OPT_IN__) {
			data[stateItem.label] = getCheckboxValue(stateItem.value);
			return;
		}
		if (key === __FIELD_OPT_IN__ && stateItem.value?.length) {
			stateItem.value.forEach(optInItem => {
				data[optInItem.label] = optInItem.checked;
			});
			return;
		}
		if (!stateItem.value) {return;}
		// 如果是user、product、 panel
		if ([__FIELD_NAME_USER_PANEL__, __FIELD_NAME_PRODUCT_PANEL__,__FIELD_NAME_PANEL__].indexOf(key) !== -1) { 
			const tmpArr = [];
			stateItem.value.forEach((item) => {
				const tmpItem = {};
				Object.keys(item).forEach(panelItemKey => {
					const panelStateItem = item[panelItemKey];
					if (!panelStateItem.value) {return;}
					// 如果是附件，则要关联上file的index，并且将附件直接追加到form data
					if ([__FIELD_NAME_INVOICE_RECEPT__, __FIELD_NAME_WARRANTY_CARD__].indexOf(panelItemKey) !== -1) {
						const relateAttach = [];
						panelStateItem.value.forEach(item => {
							attachIndex += 1;
							formData.append(`file${attachIndex}`, item);
							relateAttach.push(`file${attachIndex}`);
						});
						tmpItem[panelStateItem.label] = relateAttach.join(",");
					} else {
						tmpItem[panelStateItem.label] = isDate(panelStateItem.value) ? transformDate(panelStateItem.value) : panelStateItem.value;
					}
				});
				tmpArr.push(tmpItem);
			});
			data[key.toUpperCase()] = tmpArr;
		} else if ([__FIELD_NAME_INVOICE_RECEPT__, __FIELD_NAME_WARRANTY_CARD__].indexOf(key) !== -1) {// 如果是附件类型
			const relateAttach = [];
			stateItem.value.forEach(item => {
				attachIndex += 1;
				formData.append(`file${attachIndex}`, item);
				relateAttach.push(`file${attachIndex}`);
			});
			data[stateItem.label] = relateAttach.join(","); 
		} else {
			data[stateItem.label] = isDate(stateItem.value) ? transformDate(stateItem.value) : stateItem.value;
		}
	});
	console.log("Email form data:", data);
	formData.append("data", JSON.stringify(data));
	return formData;
};

// 判断是否是日期格式
export const isDate = (date) => {
	return date instanceof Date && !isNaN(date.getTime());
}

// 日期转换
export const transformDate = (date,format = "YYYY-MM-DD") => {
	return new Dayjs(date).format(format);
}